import produce from "immer";

// Actions
export const RECORD_DATE = "installPrompt/RECORD_DATE";
export const INSTALLED = "installPrompt/INSTALLED";

const initialState = {
  date: 0,
  installed: false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  return produce(state, (draft) => {
    switch (action.type) {
      case RECORD_DATE: {
        // Save the time if there's no state already there
        if (state.date === 0) {
          draft.date = action.date;
          break;
        }

        // else if there's already a date saved
        // Calculate the expiry date + 5 days from the saved date
        const expiryDate = state.date + 24 * 60 * 60 * 5 * 1000;
        const sameDate = state.date + 12 * 60 * 60 * 1000; // 12 hours

        // Save the new date if it's not on the same date(12hours) and is after the expiry Date
        if (action.date > expiryDate && action.date > sameDate) {
          draft.date = action.date;
        }
        break;
      }

      case INSTALLED:
        draft.installed = action.installed;
        break;
    }
  });
}

// Action Creators
export function setRecordDate(date) {
  return { type: RECORD_DATE, date };
}

export function setInstalled() {
  return { type: RECORD_DATE, installed: true };
}

// selector
export function selectInstallPrompt(state) {
  return state.installPrompt;
}
